import * as React from "react";
import {FreeTextField} from "../../../Components/Form/FreeTextField";
import {MoneyField} from "../../../Components/Form/MoneyField";
import { useForm } from "../../../../hooks/use_form_v2";
import { IBudget } from "../../../../config/budget";
import { Form } from "../../../Components/Form/Form/Form";
import { BudgetForm as BudgetFormHandler, IBudgetForm, IBudgetRequest } from "../../../../forms/settings_budget_form";

interface IBudgetFormProps {
    budget?: IBudget;
    onSubmit(data: IBudgetRequest): Promise<any>;
}

export const BudgetForm = ({budget, onSubmit}: IBudgetFormProps) => {
    const form = useForm<IBudgetForm, IBudgetRequest>(new BudgetFormHandler(budget));
    const { register, toRequest } = form;

    const handleSubmit = (values: IBudgetForm) => {
        return onSubmit(toRequest(values));
    };

    return (
        <Form form={form} onSubmit={handleSubmit}>
            <Form.Field type={FreeTextField} {...register('name')} />
            <Form.Field type={MoneyField} {...register('amount')} />
        </Form>
    );
};
